// extracted by mini-css-extract-plugin
export var searchHeader = "_2v-0";
export var searchHeaderDark = "_2v-1";